import * as Sentry from "@sentry/react"; // oxlint-disable-line no-namespace

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({ dsn: import.meta.env.VITE_SENTRY_DSN, propagateTraceparent: true });
}
